import { TranslatePipe } from '../../filters/translate.pipe';
import {Component, OnInit, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatDialogRef} from "@angular/material/dialog";
import { RouterLink } from '@angular/router';

@Component({
    standalone: true,
    selector: 'modal-success-training-program-creation',
    templateUrl: './modal-success-training-program-creation.component.html',
    imports: [CommonModule, TranslatePipe, RouterLink]
})
export class ModalSuccessTrainingProgramCreationComponent implements OnInit {
    private dialogRef = inject(MatDialogRef<ModalSuccessTrainingProgramCreationComponent>);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        this.vm.close = this.close;
    }


    close() {
        this.dialogRef.close(undefined);
    }

}